export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-1600x1200-20f285b3f91e772887128fc4bb194974.jpg";